import React, {useEffect, useState} from 'react';
import {Message} from "../../../../../theme/styledComponents";
import Input from "../../../../../components/input";
import Button from "../../../../../components/button";
import Switch from "../../../../../components/switch";
import Select from "../../../../../components/select";
import axios from "axios";
import {connect} from "react-redux";
import {getCookie} from "../../../../../theme/cookies";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExclamationTriangle} from "@fortawesome/free-solid-svg-icons";
import Spinner from "../../../../../components/spinner";
import Checkbox from "../../../../../components/checkbox";
import { isValidStringForParam } from '../../../../../utils/isValidStringForParam';
import { getErrorText } from '../../../../../utils/getErrorText';
import { API_URL } from '../../../../../config';
import SubTitle from '../../../../../components/subtitle';

function ChangeUserSettings (props) {
    const {refresh,appUserId,setShow,user} = props;

    const [valid,setValid] = useState(true);
    const [loading,setLoading] = useState();
    const [error,setError] = useState(null);

    const [state,setState] = useState({
        AppUserId: user.AppUserId,
        SettingId: 0,
        Value: ''
    });

    const options = [
        {
            key: "0",
            value: "Brak"
        },
        {
            key: "1",
            value: "Załadunki i rozładunki"
        },
        {
            key: "2",
            value: "Tylko załadunki"
        },
        {
            key: "3",
            value: "Tylko rozładunki"
        }
    ]

    const onSubmit = () => {
        setLoading(true);
        axios.patch(`${API_URL}/companies/${user.CompanyId}/user/${appUserId}/settings`,state,{
            headers:{
                'Authorization': getCookie('token')
            }
        })
            .then(res => {
                setLoading(false);
                refresh();
                setShow(false);
            })
            .catch(err => {
                setError(err.response.data.errors);
                setLoading(false);
            })
    };

    const handleChangeSelect = (e) => { 
        let value = e.target.value;
        setState({
            ...state,
            Value: value
        })
    }

    const getDocumentsRequired = () => {    
        return axios.get(`${API_URL}/companies/${user.CompanyId}/user/${appUserId}/settings/DocumentsRequired`,{
            headers:{
                'Authorization': getCookie('token')
            }
        });
    };

    const getData = () => {
        setLoading(true);
        Promise.all([getDocumentsRequired()])
            .then(([settings]) => {
                setState(settings.data);
                setLoading(false);
            }).catch((err) => {
                console.log(err);
            })
    }

    useEffect(() => {
        getData();
    },[]);


    return(
        <>
            {
                error !== null &&
                <Message>
                    <FontAwesomeIcon icon={faExclamationTriangle}/>
                    <div>
                        Nie udało się zaktualizować kierowcy.
                        <span>Error: {getErrorText(error)}</span>
                    </div>
                </Message>

            }
            <SubTitle third margin="0 0 10px">Obowiązkowy dokument do zakończenia zadania</SubTitle>
            <Select value={state.Value} renderValue={() => options.find(x => x.key === state.Value)?.value} options={options} onChange={handleChangeSelect}/>
            <Button big style={{marginTop:'10px'}} onClick={onSubmit}>
                {
                    loading ?
                        <Spinner borderWidth={3} white width={10} height={10}/> :
                        'Zapisz'
                }
            </Button>
        </>
    )
};

ChangeUserSettings.propTypes = {
};

function mapStateToProps(state) {
    return {
        user:state.auth.user
    };
}
export default connect(mapStateToProps)(ChangeUserSettings);
